import styled, { keyframes } from "styled-components";

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const Container = styled.div`
  text-align: center;
  margin-top: 80px;
`;

export const CopyButton = styled.button`
  position: relative;
  transition: all 0.3s ease;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  padding: 0;

  &:active {
    transform: scale(0.9);
  }

  &::after {
    content: "Copied!";
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
  }

  &.copied::after {
    opacity: 1;
    animation: ${fadeOut} 5s forwards;
  }
`;
